import { supabase } from "@/services/supabase/client";
import { Database } from "@/services/supabase/types";

type DbAppMetadata = Database["public"]["Tables"]["app_metadata"];
export interface AppMetadataRow extends Omit<DbAppMetadata["Row"], "metadata"> {
  metadata: Metadata;
}
export interface AppMetadataInsert extends Omit<DbAppMetadata["Insert"], "metadata"> {
  metadata?: Metadata;
}
export interface AppMetadataUpdate extends Omit<DbAppMetadata["Update"], "metadata"> {
  metadata?: Metadata;
}

export interface Metadata {
  changelog: {
    changes: string[];
    version: string;
  };
  announcement: {
    active: boolean;
    date: number; // unix timestamp
    text: string;
    type: "info" | "warning";
  };
  maintenance: {
    active: boolean;
    text: string;
  };
  showFeedback: boolean;
  update: {
    changes: [];
    mobileAppText: string;
    optionalVersion: string;
    requiredVersion: string;
    webAppText: string;
  };
}

async function getAppMetadata(): Promise<AppMetadataRow["metadata"]> {
  const { data, error } = await supabase.from("app_metadata").select("metadata").single();

  if (error) throw error;

  return data.metadata as AppMetadataRow["metadata"];
}

export const appMetadataFetchers = {
  getAppMetadata,
};
